<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <article v-else>
            <HeroBasic
                :title="entry?.title"
                :description="entry?.description"
            >
                <template
                    v-if="entry?.parent"
                    #backlink
                >
                    <NuxtLink :to="localePath(`/${entry?.parent?.uri}`)">
                        <div class="sr-only">{{ t('a11y.return-to') }}</div>
                        <BaseIcon icon="chevron-left" />
                        {{ entry?.parent?.title }}
                    </NuxtLink>
                </template>
            </HeroBasic>

            <FlexibleSections
                v-if="entry.flexibleSections"
                :sections="entry.flexibleSections"
            />

            <BaseSection>
                <DeadlinesOverview />
            </BaseSection>
        </article>
    </div>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getPage from '~/graphql/queries/getPage.graphql';

const { t } = useI18n();
const localePath = useLocalePath();

const { variables: defaultVariables }  = useCraftGraphql();

const now = formatISO(Date.now(), { representation: 'date' });

const variables = computed(() => {
    return {
        ...defaultVariables,
        uri: 'deadlines',
        now: ['or', `>= ${now}`, null]
    };
});

const response = await useAsyncQuery({
    query: getPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);

const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry?.value?.showNewsletterSubscribe ?? false);
});
</script>
